/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import FlashOptions from './flash_options'
import { cleanString } from '../util'
import _ from 'underscore'
import MCPOptions from './multiple_choice_poll_options.js'
import DiscourseResults from './discourse_results.js'
import Results from './results.js'
import $ from 'jquery'
import URI from 'urijs'

/*
 * Model to fetch data from the public polls API
 *
 * TODO: think about how to define these as a public API so we know exactly
 *       what methods we need when doing stuff like this in the future.
 */
export default class PublicPoll extends Base {
  initialize (options) {
    if (options == null) { options = {} }
    this.options = options
    return _.defaults(this.options,
      { randomizeResults: true })
  }

  // these are overridden by MCPs
  isGraded () {
    return false
  }

  hasAlphaNumericKeyword () {
    return false
  }

  hasCustomGlobalKeyword () {
    return false
  }

  shouldHideKeywords () {
    return true
  }

  highestResponse () {
    if ((this.mcpOptions != null ? this.mcpOptions.length : undefined)) {
      /*
       * If the mcp options don't have this property, highestResult
       * returns -Infinity, which ends up crashing the browser.
       */
      if (this.mcpOptions.models[0].get('results_count')) {
        return this.mcpOptions.highestResult()
      } else {
        return 0
      }
    } else {
      return null
    }
  }

  // this is overridden by FTPs
  supportsModeration () {
    return false
  }

  // FTP/Discourse calls this when results change
  updateResults () {
    return this.results.reset(this.attributes.results)
  }

  flashOptions () {
    if (!this._flashOptions) { this._flashOptions = new FlashOptions() }
    this._flashOptions.poll = this

    // Don't fetch flash options from server
    this._flashOptions.fetch = () => (new $.Deferred()).resolve()

    return this._flashOptions
  }

  type () {
    return this.get('type')
  }

  url () {
    return URI('/api/example/polls').segment(this.id.toString()).toString()
  }

  cleanTitle (opts) {
    if (opts == null) { opts = {} }
    opts = _.defaults(opts,
      { emoji: 'image' })

    const title = this.get('title')
    return cleanString(title, opts)
  }

  parse (json) {
    // This api includes the flash options
    if (json == null) { json = {} }
    this.flashOptions().set(json.flash_options)

    switch (json.type) {
      case 'multiple_choice_poll': case 'ranking_poll':
        if (this.options.randomizeResults) { this.randomizeResults(json) }

        this.mcpOptions = new MCPOptions(json.options)
        this.mcpOptions.poll = this
        break

      case 'discourse':
        this.results = new DiscourseResults()
        this.results.poll = this
        break

      case 'free_text_poll':
        this.results = new Results()
        this.results.poll = this
        break
    }

    delete json.flash_options

    return json
  }

  randomizeResults (json) {
    // Random results count
    json.options.forEach(option => {
      option.results_count = _.random(1, 10)
    })

    // Set total results
    json.results_count = _.inject(json.options, (total, option) =>
      total + option.results_count, 0
    )

    // Set results percentages
    json.options.forEach(option => {
      option.results_percentage = Math.round((option.results_count / json.results_count) * 100)
    })
  }

  // This method should be called after changing a results_count to update all the calculations
  updateTotalsAndPercentages () {
    // Set total results
    const totalResults = _.inject(this.mcpOptions.pluck('results_count'), (total, num) => total + num, 0)
    this.set({ results_count: totalResults })

    // Set results percentages
    return this.mcpOptions.each(option => {
      return option.set({ results_percentage: Math.round((option.get('results_count') / this.get('results_count')) * 100) })
    })
  }
}
